import React from 'react';

const defaultValue = {
    isMobile: false,
    screenType: {},
    queryClassName: null,
};

export default React.createContext(defaultValue);
